<template>
  <b-modal title="Informações Sobre a Entrada" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="10">
          <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cliente" v-model="editing.cliente" />
          </b-form-group>
        </b-col>

        <b-col cols="1">
          <b-form-select v-model="selecionado">
            <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
              >{{ cliente.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nota Fiscal:" label-for="fiscal" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="fiscal" v-model="editing.notafiscal" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Recebedor:" label-for="receb" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="receb" v-model="editing.recebeu" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Setor:" label-for="setor" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="setor" v-model="editing.setor" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Enviou:" label-for="entr" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="entr" v-model="editing.entregou" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Entrada from "@/models/Entrada";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDeEntrada",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: new Entrada(0, "Nova Entrada", "", new Date(), "", "", "", ""),
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente.nome;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.entradaSaidaStore.ALTERAR_ENTRADA(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Entrada de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.entradaSaidaStore
          .CADASTRAR_ENTRADA(this.editing)
          .then(() =>
            this.store.NOTIFICAR(new Notificacao("Entrada de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"))
          );
      }
      this.show = !this.show;
    },

    call(entrada) {
      this.show = !this.show;
      this.editing = entrada;
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const clienteStore = useClienteStore();

    return {
      store,
      entradaSaidaStore,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
